/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import CredentialsController from './credentials.controller';
import SelectEntityController from './select-entity.controller';
import Dialogs from './dialogs.service';

export default angular.module('tektelic.dialog', [])
    .controller('CredentialsController', CredentialsController)
    .controller('SelectEntityController', SelectEntityController)
    .factory('tkDialogs', Dialogs)
    .name;



// WEBPACK FOOTER //
// ./src/app/dialog/index.js